<template>
  <div>
    <top-header-info></top-header-info>
    <div>
      <div class="w">
        <div class="top_info">
          <el-row>
            <el-col :span="12" class="title">您的订单已提交成功！ 请您尽快付款！</el-col>
            <el-col :span="12" class="price">
              <div>
                订单金额：
                <span class="red_word">{{orderInfo.total | yuan}}</span>元
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="hint">
              请您在提交订单后
              <pay-countdown v-if="endTime" class="count" :endTime="endTime"></pay-countdown>内完成支付，否则订单会自动取消
            </el-col>
            <el-col :span="12" class="show_detail">
              <div @click="showDetail=!showDetail">
                订单详情
                <i class="el-icon-caret-bottom"></i>
              </div>
            </el-col>
          </el-row>
          <el-row class="order_detail" v-show="showDetail">
            <el-col :span="10">
              收货人：
              <span>{{orderInfo.name}} {{orderInfo.phone}}</span>
            </el-col>
            <el-col :span="14">
              订单号：
              <span>{{orderInfo.id}}</span>
            </el-col>
            <el-col class="products_name">
              <el-row>
                <el-col :span="6">
                  场地：
                  <span>{{orderInfo.qu_yun_dong_order&&orderInfo.qu_yun_dong_order[0].venues_name}}</span>
                </el-col>
                <el-col :span="4">
                  项目：
                  <span>{{orderInfo.qu_yun_dong_order&&orderInfo.qu_yun_dong_order[0].cat_id}}</span>
                </el-col>
                <el-col :span="6">
                  日期：
                  <span>{{orderInfo.qu_yun_dong_order&&orderInfo.qu_yun_dong_order[0].date | dateFormat3}}</span>
                </el-col>
                <el-col class="times_wrap">
                  场次：
                  <div
                    v-for="item in orderInfo.qu_yun_dong_order&&orderInfo.qu_yun_dong_order"
                    :key="item.id"
                  >{{item.field_name}} {{item.time}} {{item.end_time}} {{item.price | intYuan}}</div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div class="bottom_info">
          <div class="bot_title">选择的支付方式：{{orderInfo.payment_method}}</div>
          <el-radio-group v-model="orderInfo.payment_method" v-if="!showBarcode">
            <el-row class="pay_item" v-show="orderInfo.payment_code=='credit'">
              <el-col :span="20">
                <el-radio label="账户余额"></el-radio>
                <img width="40" height="40" src="../../assets/images/yue.png" align="center" /> &nbsp;账户余额
                <span class="remain">
                  可用余额：
                  <span class="red_word">{{balance |yuan}}</span>
                  <!-- <el-button size="small" class="recharge">立即充值</el-button> -->
                </span>
              </el-col>
              <el-col :span="4">
                还需付款：
                <span class="red_word">{{orderInfo.total | yuan}}</span>
              </el-col>
            </el-row>
            <el-row class="pay_item" v-show="orderInfo.payment_code!='credit'">
              <el-col :span="20">
                <el-radio label="支付宝支付"></el-radio>
                <img width="40" height="40" src="../../assets/images/ali.png" align="center" /> &nbsp;支付宝
              </el-col>
              <el-col :span="4" v-show="orderInfo.payment_code=='alipay_direct'">
                还需付款：
                <span class="red_word">{{orderInfo.total | yuan}}</span>
              </el-col>
            </el-row>
            <el-row class="pay_item" v-show="orderInfo.payment_code!='credit'">
              <el-col :span="20">
                <el-radio label="微信扫码支付"></el-radio>
                <img width="40" height="40" src="../../assets/images/weixin.png" align="center" /> &nbsp;微信
              </el-col>
              <el-col :span="4" v-show="orderInfo.payment_code=='qrcode_wxpay'">
                还需付款：
                <span class="red_word">{{orderInfo.total | yuan}}</span>
              </el-col>
            </el-row>
          </el-radio-group>
          <div v-else class="weixin_pay clearfix">
            <div class="left_code">
              <img :src="code" alt="code" />
              <p>微信扫一扫支付</p>
            </div>
            <div class="right_img">
              <img src="../../assets/images/weixin_scan.png" alt />
            </div>
          </div>
        </div>
        <div class="but_wrap" v-if="!showBarcode">
          <el-button @click="doPayNow">立即支付</el-button>
        </div>
      </div>
      <bottom-content></bottom-content>
    </div>
    <div class="mask_wrap" v-if="showMask">
      <div>
        <el-row class="mask_title">
          <el-col :span="23">
            <p>
              <i :class="statusClass"></i>
              {{statusText}}！
            </p>
          </el-col>
          <el-col :span="1">
            <i class="el-icon-close"></i>
          </el-col>
        </el-row>
        <el-row class="mask_info">
          <el-col :span="12">
            <img :src="orderInfo.products && orderInfo.products[0].product_image" alt />
          </el-col>
          <el-col :span="12">
            <div class="goods_title">{{orderInfo.products && orderInfo.products[0].name}}</div>
            <ul>
              <li>
                <span>订单编号</span>
                {{userOrderInfo.id}}
              </li>
              <li>
                <span>订单信息</span>
                {{userOrderInfo.name}}{{userOrderInfo.phone}}
              </li>
              <li>
                <span>项目</span>
                {{userOrderInfo.qu_yun_dong_order && userOrderInfo.qu_yun_dong_order[0].cat_id}}
              </li>
              <li>
                <span>日期</span>
                {{userOrderInfo.qu_yun_dong_order && userOrderInfo.qu_yun_dong_order[0].date | dateFormat2}}
              </li>
              <li>
                <span>场次</span>
                <div
                  class="times"
                  v-for="item in userOrderInfo.qu_yun_dong_order"
                  :key="item.field_id"
                >{{item.field_name}} {{item.time}}-{{item.end_time}} {{item.price | intYuan}}</div>
              </li>
            </ul>
          </el-col>
        </el-row>
        <el-row class="mask_button">
          <el-col :span="12">
            <router-link v-if="isSuccess" :to="{name:'index'}" replace>返回首页</router-link>
            <router-link v-else :to="{}" @click.native="showMask=false">返回重新支付</router-link>
          </el-col>
          <el-col :span="12">
            <router-link :to="{name:'order-detail'}" replace>查看订单</router-link>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import BottomContent from "@/components/bottom-content";
import payCountdown from "@/components/pay-countdown/index.vue";

export default {
  components: {
    TopHeaderInfo,
    BottomContent,
    payCountdown
  },
  data() {
    return {
      showDetail: false,
      payway: "",
      orderInfo: "",
      isSuccess: false,
      showMask: false,
      showBarcode: false,
      timer: "",
      balance: 0,
      endTime: ""
    };
  },
  mounted() {
    this.getData();
    this.getBalance();
  },
  computed: {
    statusClass() {
      return this.isSuccess ? "el-icon-circle-check" : "el-icon-circle-close";
    },
    statusText() {
      return this.isSuccess ? "支付成功" : "支付失败";
    }
  },
  methods: {
    getData() {
      this.$reqGet(
        "api/store/quyundong_order/" + this.$route.params.order_id
      ).then(res => {
        this.orderInfo = res.data.data.order;
        if (this.orderInfo.iso_end_time) {
          this.endTime = this.orderInfo.iso_end_time;
        }
      });
    },
    doPayNow() {
      let payMethod = this.orderInfo.payment_method;
      if (payMethod == "支付宝支付") {
        this.aliPay();
      } else if (payMethod == "微信扫码支付") {
        this.wxpay();
      } else if (payMethod == "账户余额") {
        setTimeout(() => {
          this.showMask = true;
          this.isSuccess = true;
        }, 1000);
      } else {
        this.$message({ message: "暂不支持此支付方式", type: "warning" });
      }
    },
    getBalance() {
      this.$reqGet("api/distribch/account/balance").then(res => {
        this.balance = res.data.data.balance;
      });
    },
    // 支付宝
    aliPay() {
      this.$reqPost("api/store/payment/aliWeb/" + this.orderInfo.id).then(
        res => {
          let html = res.data.data.pay;
          document.body.innerHTML = html;
          document.forms["alipay_submit"].submit();
        }
      );
    },
    // 微信支付
    wxpay() {
      this.$reqPost("api/store/payment/wxScan/" + this.orderInfo.id).then(
        res => {
          this.showBarcode = true;
          this.code = res.data.data.pay;
        }
      );
      this.check();
    },
    check() {
      this.timer = setInterval(() => {
        this.$reqGet("api/store/order/paid_status/" + this.orderInfo.id).then(
          res => {
            if (res.data.data.success) {
              clearInterval(this.timer);
              this.isSuccess = true;
              this.$reqGet(
                "api/store/quyundong_order/" + this.orderInfo.id
              ).then(res => {
                this.userOrderInfo = res.data.data.order;
              });
              this.showMask = true;
            }
          }
        );
      }, 3000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="less" scoped>
.top_info {
  padding: 20px 30px;
  .title {
    font-size: 20px;
    color: rgba(34, 34, 34, 1);
    line-height: 36px;
  }
  .price {
    text-align: right;
  }
  .hint {
    line-height: 36px;
  }
  .show_detail {
    text-align: right;
    color: #222;
    cursor: pointer;
    i {
      color: #aaa;
    }
  }
  .order_detail {
    border-top: 1px solid #ddd;
    color: #999;
    line-height: 36px;
    span {
      color: #333;
    }
    .products_name .times_wrap {
      > div {
        display: inline-block;
        color: #333;
        margin-right: 30px;
      }
    }
  }
}
.el-radio /deep/ .el-radio__label {
  font-size: 0;
}
.el-radio /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #e2333f;
  background-color: #e2333f;
}
.bottom_info {
  background-color: #fff;
  padding: 20px 30px;
  .el-radio-group {
    display: block;
    font-size: 14px;
    .recharge {
      border: 1px solid rgba(226, 51, 63, 1);
      border-radius: 13px;
      height: 26px;
      line-height: 26px;
      padding-top: 0;
      margin-left: 8px;
      color: rgba(226, 51, 63, 1);
    }
    .red_word {
      color: #fb0010;
    }
  }
  .bot_title {
    font-size: 16px;
    color: rgba(34, 34, 34, 1);
    line-height: 36px;
    border-bottom: 2px solid #ddd;
  }
  .pay_item {
    padding: 20px;
    border-bottom: 1px solid #ddd;
    line-height: 40px;
    box-sizing: border-box;
    img {
      width: 40px;
      height: 40px;
      margin-left: -30px;
    }
    .remain {
      margin-left: 15px;
    }
  }
}
.statusIcon {
  width: 20px;
}
.but_wrap {
  padding: 30px;
  text-align: right;
  background-color: #fff;
  .el-button {
    width: 198px;
    height: 46px;
    background: rgba(226, 51, 63, 1);
    border-radius: 5px;
    font-size: 16px;
    color: #fff;
    border: none;
  }
}
.mask_wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(1, 1, 1, 0.6);
  > div {
    position: absolute;
    width: 800px;
    padding: 0 15px;
    height: 450px;
    background: rgba(255, 255, 255, 1);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .mask_title {
    text-align: center;
    font-size: 26px;
    margin: 10px 20px;
    color: #333;
    border-bottom: 1px solid #bbb;
    i {
      color: #bbb;
    }
    .el-icon-circle-check {
      color: #5eb95a;
    }
    .el-icon-circle-close {
      color: #e2333f;
    }
  }
  .mask_info {
    > div:first-child {
      text-align: center;
      img {
        width: 190px;
        height: 190px;
        margin-top: 20px;
      }
    }
    .goods_title {
      font-size: 20px;
      color: rgba(0, 0, 0, 1);
      line-height: 32px;
    }
    li {
      color: #222;
      line-height: 30px;
      span {
        display: inline-block;
        width: 70px;
        color: #999;
        text-align-last: justify;
        margin-right: 10px;
      }
    }
  }
  .mask_button {
    padding: 30px 150px;
    text-align: center;
    a {
      display: inline-block;
      width: 146px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color: #fff;
      background: rgba(226, 51, 63, 1);
      border-radius: 5px;
    }
    > div:last-child a {
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(219, 219, 219, 1);
      color: #333;
    }
  }
}
.weixin_pay {
  > div {
    display: inline-block;
    width: 47%;
  }
  .left_code {
    float: left;
    text-align: center;
    padding-top: 120px;
    padding-left: 60px;
    img {
      width: 160px;
      height: 160px;
      border: 1px solid rgba(205, 205, 205, 1);
      padding: 3px;
    }
  }
  .right_img {
    img {
      width: 280px;
      margin-top: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/qyd-submit-order.vue